import React, { useEffect, useState } from "react";
import {
  Grid,
  Box,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  FormControl,
  MenuItem,
  Select,
  IconButton,
  Skeleton,
  Button,
  Modal,
  keyframes,
} from "@mui/material";
import PushPinIcon from "@mui/icons-material/PushPin";
import PushPinOutlinedIcon from "@mui/icons-material/PushPinOutlined";
import CloseIcon from "@mui/icons-material/Close";
import OpenInNewOutlinedIcon from "@mui/icons-material/OpenInNewOutlined";
import MobileScreenShareRoundedIcon from "@mui/icons-material/MobileScreenShareRounded";
import {
  actionIconStyle,
  tableCellStyle,
  menuItemStyle,
} from "../../style/AppointmentStyle";
import UseFetchAppointmentList from "../../helper/UseFetchAppointmentList";
import { useDispatch, useSelector } from "react-redux";
import {
  setPrescriptionData,
  setPatientDetailsData,
  setAppointmentData,
  setRenderPrescriptionTable,
  setSearchPatient,
} from "../../redux/slices/prescriptionSlice";
import UsePatientDetail from "../../helper/UsePatientDetail";
import UsePatientDetailPrescription from "../../helper/UsePatientDetailPrescription";
import UseFetchAppointmentDetailsPatient from "../../helper/UseFetchAppointmentDetailsPatient";
import { cancelAppointment } from "../../connections/putApi";
import { pinPatientAppointment } from "../../connections/putApi";
import { showToast } from "../../utils/toastUtil.js";
import { useLocation, useNavigate } from "react-router-dom";
import hero from "../../assets/hero.png";
import {
  primaryBtnTeal,
  selectFieldPrep,
} from "../../style/PatientDetailsStyle/index.js";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import bye from "../../assets/bye.svg";
import loadingSpinner from "../../assets/loadingSpinner.svg";
import { summaryOfPatientRecording } from "../../connections/getApi.js";
import PatientSummaryDialog from "../CustomModal/PatientSummaryDialog.jsx";
import CustomModal from "../CustomModal/CustomModal.jsx";
import PatientHistorySummary from "../ModalChildren/PatientHistorySummary.jsx";
import { getPatientAiSummary } from "../../connections/getApi.js";
import LocalPhoneOutlinedIcon from "@mui/icons-material/LocalPhoneOutlined";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timezone);

const rotateSpinner = keyframes`
0% { transform: rotate(0deg); }
10% { transform: rotate(36deg); }
20% { transform: rotate(72deg); }
30% { transform: rotate(108deg); }
40% { transform: rotate(144deg); }
50% { transform: rotate(180deg); }
60% { transform: rotate(216deg); }
70% { transform: rotate(252deg); }
80% { transform: rotate(288deg); }
90% { transform: rotate(324deg); }
100% { transform: rotate(360deg); }
`;

const DoctorDetail = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [selectedPatientId, setSelectedPatientId] = useState(null);
  const [selectedAppointmentId, setSelectedAppointmentId] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [startYourDay, setStartYourDay] = useState(
    localStorage.getItem("startDay") || false,
  );
  const [appointmentsDate, setAppointmentsDate] = useState([]);

  // Check localStorage on component mount
  useEffect(() => {
    const startDayData = localStorage.getItem("startDay");
    if (startDayData) {
      const { value, expiry } = JSON.parse(startDayData);
      if (value === "true" && new Date().getTime() < expiry) {
        setStartYourDay(true);
      } else {
        localStorage.removeItem("startDay");
      }
    }
  }, []);

  const handleDayStart = () => {
    const expiryTime = new Date().getTime() + 10 * 60 * 60 * 1000; // 10 hours in ms
    localStorage.setItem(
      "startDay",
      JSON.stringify({
        value: "true",
        expiry: expiryTime,
      }),
    );
    localStorage.removeItem("cabinEntries");
    setStartYourDay(true);
  };

  const [cabinEntries, setCabinEntries] = useState(() => {
    const saved = localStorage.getItem("cabinEntries");
    return saved ? JSON.parse(saved) : {};
  });

  const [openSummaryModal, setOpenSummaryModal] = useState(false);
  const [voiceSummary, setVoiceSummary] = useState(false);
  const [openHistoryModal, setOpenHistoryModal] = useState(false);
  const [patientAiSummaryData, setPatientAiSummaryData] = useState(null);

  const handleOpenSummary = async () => {
    await refetch(); // make sure latest data is fetched
    setOpenSummaryModal(true); // open modal
  };

  const handleCloseSummary = () => {
    setOpenSummaryModal(false);
  };

  const handleSelect = async (id, appointmentId) => {
    const now = dayjs().tz("Asia/Kolkata").toISOString();
    // ISO format: you can customize it

    // Get previous entries from localStorage
    let entries = JSON.parse(localStorage.getItem("cabinEntries")) || [];
    // Check if already exists
    if (entries?.id) {
      const newEntry = { id: id, entryTime: entries?.entryTime };
      localStorage.setItem("cabinEntries", JSON.stringify(newEntry));
      setCabinEntries(entries);
    } else {
      const newEntry = { id: id, entryTime: now };
      localStorage.setItem("cabinEntries", JSON.stringify(newEntry));
      setCabinEntries(entries);
    }

    // const alreadyExists = entries.some((entry) => entry.id === id);
    // if (!alreadyExists) {
    //   entries.push({ id: id, entryTime: now });
    //   // Update localStorage
    //   localStorage.setItem("cabinEntries", JSON.stringify(entries));
    //   // Optional: also update local state
    //   setCabinEntries(entries);
    // }
    setSelectedAppointmentId(appointmentId);
    setTimeout(() => {
      setSelectedPatientId(id);
    }, 0);
    dispatch(setSearchPatient([]));

    // Reset previous AI summary
    setPatientAiSummaryData(null);
    setOpenHistoryModal(false);

    try {
      const resSummary = await summaryOfPatientRecording(appointmentId);
      // if (resSummary);
      if (resSummary?.status?.status === "SUCCESS") {
        handleOpenSummary();
        setVoiceSummary(resSummary);
      }
    } catch (error) {
      console.error(error, "error");
    }

    try {
      const aiSummaryRes = await getPatientAiSummary(
        id,
        appointmentId,
        "Appointment",
        "octabot",
      );

      const summary = aiSummaryRes?.payload?.summary;

      if (summary && Object.keys(summary)?.length > 0) {
        setPatientAiSummaryData(aiSummaryRes.payload.summary);
        setOpenHistoryModal(true);
      }
    } catch (error) {
      console.error(error, "error fetching patient AI summary");
    }
  };

  // console.log(cabinEntries, ' cabinEntries')

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const patientId = query.get("patientId");
    // console.log(patientId);
    if (patientId) {
      setSelectedPatientId(patientId);
      query.delete("patientId");
      navigate({ search: query.toString() }, { replace: true });
    }
  }, [location, navigate]);

  const cancelPatientAppointment = async (id, e) => {
    dispatch(setRenderPrescriptionTable());
    e.stopPropagation();

    const confirmed = window.confirm(
      "Are you sure you want to cancel this appointment?",
    );
    if (confirmed) {
      const response = await cancelAppointment(id);
      if (!response.error) {
        refetch();
        setSelectedRow(null);
        showToast("appointment cancel", "SUCCESS");
      } else {
        console.error("Failed to cancel appointment:", response.msg);
        showToast("Failed to cancel appointment", "ERROR");
      }
    }
  };

  const pinAppointment = async (id, e) => {
    e.stopPropagation();
    const response = await pinPatientAppointment(id);
    if (!response.error) {
      refetch();
      // console.log(response.payload);
      showToast("SUCCESS  ", "SUCCESS");
    } else {
      console.error("Failed to pin appointment:");
    }
  };

  const handleRedirect = (patientId, e) => {
    e.stopPropagation();
    const newTabUrl = `${window.location.origin}${window.location.pathname}?patientId=${patientId}`;
    window.open(newTabUrl, "_blank");
  };

  // Fetch patient details when a patient is selected
  const { data: patientDetails, isLoading: patientDetailsLoading } =
    UsePatientDetail(selectedPatientId);
  const { data: appointmentDetails, isLoading: appointmentDataLoading } =
    UseFetchAppointmentDetailsPatient(
      selectedAppointmentId || patientDetails?.payload?.appointments[0]?.id,
    );

  const {
    data: prescriptionDetails,
    isLoading: prescriptionDataLoading,
    status: prescriptionStatus,
  } = UsePatientDetailPrescription(
    (appointmentDetails?.prescription?.id &&
      appointmentDetails?.prescription?.id) ||
      (appointmentsDate?.length >= 2 && appointmentsDate[1]?.prescription_id),
  );

  // Dispatch data to Redux store when it changes
  useEffect(() => {
    if (patientDetails) {
      dispatch(setPatientDetailsData(patientDetails?.payload));
      // dispatch(setAppointmentData({}))
    }
    if (patientDetails?.payload?.appointments) {
      const dates = patientDetails?.payload?.appointments
        .filter(
          (appointment) =>
            ["completed", "paid"].includes(appointment?.status) ||
            appointment?.prescription_id,
        )
        .map((appointment) => ({
          date: dayjs(appointment.visit_date).tz("Asia/Kolkata").format("ddd MMM DD YYYY"),
          id: appointment.id, // Track the appointment ID for fetching details
          prescription_id: appointment?.prescription_id,
          appointmentStatus: appointment?.status,
        }));
      setAppointmentsDate(dates);
    } else {
      setAppointmentsDate([]);
    }
  }, [patientDetails, dispatch]);

  // console.log(appointmentsDate ,'appointmentsDate hello')

  useEffect(() => {
    if (appointmentDetails) {
      dispatch(setAppointmentData(appointmentDetails));
      // dispatch(setAppointmentData({}));
      dispatch(setPrescriptionData([]));
    }
  }, [appointmentDetails, dispatch]);

  const authState = useSelector((state) => state.auth);

  const [allDataLoading, setAllDataLoading] = useState(false);
  // Debounce effect to stabilize allDataLoading state
  useEffect(() => {
    if (patientDetailsLoading) {
      // console.log(patientDetailsLoading);
      setAllDataLoading(true); // Set to true immediately when patientDetailsLoading starts
    } else if (
      !patientDetailsLoading &&
      !appointmentDataLoading &&
      !prescriptionDataLoading
    ) {
      // Use a timeout to debounce the false state change
      const timer = setTimeout(() => {
        setAllDataLoading(false);
        // console.log("i am loader", "all api loader");
      }, 1000);

      return () => clearTimeout(timer); // Clear timeout if dependencies change before debounce ends
    }
  }, [patientDetailsLoading, appointmentDataLoading, prescriptionDataLoading]);

  useEffect(() => {
    if (prescriptionDetails && prescriptionStatus === "success") {
      // console.log(prescriptionDetails  ,'prescriptionDetails first ' , prescriptionDetails , prescriptionStatus)
      if (appointmentDetails?.prescription?.id) {
        setTimeout(() => {
          dispatch(setPrescriptionData(prescriptionDetails));
        }, 550);
      } else if (
        appointmentsDate?.length >= 2 &&
        appointmentsDate[1]?.prescription_id
      ) {
        setTimeout(() => {
          const { id, ...prescriptionWithoutId } = prescriptionDetails;
          dispatch(setPrescriptionData(prescriptionWithoutId));
        }, 550);
      }
    }
  }, [prescriptionDetails]);

  // console.log(appointmentsDate , 'appointmentsDate doctor details')
  // useEffect(() => {
  //   const fetchPrescription = async () => {
  //     if (!appointmentDetails?.prescription_id) {
  //       if (patientDetailsData?.appointments?.length > 1 && !patientDetailsData?.appointments[0]?.prescription_id) {

  //         let prescriptionTruthyId = null;

  //         for (let appointment of patientDetailsData?.appointments) {
  //           if (appointment.prescription_id) {
  //             prescriptionTruthyId = appointment.prescription_id;
  //             break; // Stop at the first truthy prescription_id
  //           }
  //         }
  //         if (prescriptionTruthyId) {
  //           try {
  //             const res = await getPatientPrescription(prescriptionTruthyId);
  //             // console.log(res, "Fetched Prescription Data TO save medicine from an prev prescription");

  //             if (res) {
  //               dispatch(setPrescriptionData(res));
  //             }
  //           } catch (error) {
  //             console.error("Error fetching prescription:", error);
  //           }
  //         } else {
  //           console.warn("No truthy prescription ID found in appointments");
  //         }
  //       }
  //     }
  //   };
  //   fetchPrescription();
  // }, [appointmentDetails]);

  const { doctorOptions, renderPrescriptionTable } = useSelector(
    (state) => state.prescription,
  );
  // console.log(doctorOptions, 'doctorOptions');

  const [date, setDate] = useState(
    dayjs().tz("Asia/Kolkata").format("YYYY-MM-DD"),
  ); //  const [date, setDate] = useState('2024/10/14');
  const [data, setData] = useState({
    visitDate: date,
    status: "paid",
    // visitIteq: undefined,
    doctorId: 1,
  });

  const {
    data: filterList,
    refetch,
    isError,
    isLoading,
  } = UseFetchAppointmentList(data);

  const sortedAppointments = filterList?.appointments?.sort((a, b) => {
    if (a.pinned_sequence && !b.pinned_sequence) return -1;
    if (!a.pinned_sequence && b.pinned_sequence) return 1;
    return 0;
  });

  //  console.log(filterList);
  // console.log(isError, "error");
  // const patientDetailsData = useSelector(
  //   (state) => state.prescription.patientDetailsData
  // );

  const handleDoctorChange = (event) => {
    setData((prev) => ({
      ...prev,
      doctorId: event.target.value,
    }));
  };

  useEffect(() => {
    refetch(data);
  }, [data, renderPrescriptionTable]);

  // console.log(data, filterList);

  function getGreeting() {
    const now = dayjs().tz("Asia/Kolkata");
    const hours = now.hour(); // Get the current hour in IST (0-23)

    if (hours < 12) {
      return "Good Morning";
    } else if (hours < 18) {
      return "Good Afternoon";
    } else if (hours < 21) {
      return "Good Evening";
    } else {
      return "Good Night ";
    }
  }

  const VisitTypeChip = ({ type }) => {
    const config = {
      new: { label: "New", color: "#E3F2FD", text: "#1565C0" },
      old: { label: "Old", color: "#E8F5E9", text: "#2E7D32" },
      complimentary: {
        label: "CPMY",
        color: "#FFF3E0",
        text: "#EF6C00",
      },
      review: { label: "Review", color: "#F3E5F5", text: "#6A1B9A" },
    };

    const chip = config[type?.toLowerCase()] || config.new;

    return (
      <Box
        sx={{
          px: 1.4,
          py: 0.3,
          borderRadius: "6px",
          fontSize: 12,
          fontWeight: 600,
          backgroundColor: chip.color,
          color: chip.text,
          textAlign: "center",
          textTransform: "capitalize",
        }}
      >
        {chip.label}
      </Box>
    );
  };

  return (
    <Grid
      sx={{
        backgroundColor: "neutral.white",
        border: "2px solid #E1E1E1",
        marginRight: -1,
        padding: 1,
        paddingX: 0.5,
        paddingTop: 3,
        borderTopLeftRadius: "20px",
      }}
      container
      justifyContent="center"
      // minWidth={'30%'}
      lg={3.8}
      md={3.8}
      xs={12}
    >
      {!startYourDay ? (
        <Box sx={{ width: "100%" }}>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              flexDirection: "row",
              justifyContent: "space-between",
              backgroundColor: "#EEF6F9",
              borderRadius: "20px",
              height: "185px",
              marginTop: "100px",
            }}
          >
            <Box sx={{ marginTop: "-80px" }}>
              <img src={hero} alt="" width={"210px"} />
            </Box>

            <Box sx={{ paddingRight: "30px", marginTop: "-10px" }}>
              <Typography fontSize={"22px"} fontWeight={"bold"}>
                {" "}
                {getGreeting()}{" "}
              </Typography>
              <Typography
                fontSize={"22px"}
                fontWeight={"bold"}
                color={"neutral.teal"}
              >
                {" "}
                Dr. {authState?.first_name} {authState?.last_name}{" "}
              </Typography>
              <Typography sx={{ marginTop: "8px" }}>
                {" "}
                Have a nice day at work
              </Typography>
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              marginTop: "35px",
            }}
          >
            <Button
              sx={{
                ...primaryBtnTeal,
                color: "white",
                width: "200px",
                fontSize: "14px",
              }}
              onClick={handleDayStart}
              className="btn draw-border"
            >
              Start your day{" "}
              <ArrowForwardOutlinedIcon sx={{ marginLeft: "5px" }} />
            </Button>
          </Box>
        </Box>
      ) : (
        <Grid item xs={12} sx={{ padding: 1, paddingRight: 1.6 }}>
          {/* Doctor list */}
          <Box
            display="flex"
            alignItems="center"
            justifyContent={"space-between"}
          >
            <FormControl variant="outlined">
              <Select
                fullWidth
                // sx={{
                //   ...selectField,
                // }}
                sx={{ ...selectFieldPrep, paddingX: "4px", minWidth: "200px" }}
                value={data?.doctorId || ""}
                onChange={handleDoctorChange}
                name="doctor"
                displayEmpty
              >
                <MenuItem value="" disabled>
                  <span>{"Select Doctor"}</span>
                </MenuItem>
                {doctorOptions?.map((option) => (
                  <MenuItem
                    id={option?.value || "menu"}
                    key={option.value + Math.random()}
                    value={option.id}
                    sx={menuItemStyle}
                  >
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {filterList?.appointments?.length > 0 && (
              <Typography
                letterSpacing={"0.15px"}
                variant="heading1"
                color={"neutral.teal"}
                fontSize={"18px"}
              >
                {" "}
                Appointments : {filterList?.appointments?.length || 0}
              </Typography>
            )}
          </Box>

          {
            isLoading ? (
              <TableContainer>
                <Table>
                  <TableBody>
                    {[1, 2, 3, 4, 5].map((_, index) => (
                      <TableRow key={index}>
                        <TableCell>
                          <Skeleton variant="text" width="100%" height={30} />
                        </TableCell>
                        <TableCell>
                          <Skeleton variant="text" width="100%" height={30} />
                        </TableCell>
                        <TableCell>
                          <Skeleton variant="text" width="100%" height={30} />
                        </TableCell>
                        <TableCell>
                          <Skeleton
                            variant="rounded"
                            width="100%"
                            height={30}
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <Box
                sx={{
                  mt: 2,
                  maxHeight: "100vh",
                  minHeight: "70vh",
                  overflowY: "auto",
                  overflowX: "hidden",
                }}
              >
                {filterList?.appointments?.length > 0 ? (
                  filterList.appointments.map((patient, index) => (
                    <Box
                      key={patient.id}
                      onClick={() => {
                        handleSelect(patient?.patient_id, patient?.id);
                        setSelectedRow(patient?.patient_id);
                      }}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0.5,
                        flexWrap: "wrap", // 🔥 allow wrapping
                        backgroundColor: "white",
                        borderRadius: "16px",
                        p: 1.2,
                        mb: 1.5,
                        cursor: "pointer",
                        minWidth: 0, // 🔥 important
                        overflow: "visible",
                        outline:
                          selectedRow === patient?.patient_id
                            ? "2px solid #007A99"
                            : "2px solid #E1E1E1",
                        outlineOffset: "-2px",
                      }}
                    >
                      {/* TIME  + Type*/}
                      <Box
                        sx={{
                          flex: 1,
                          display: "flex",
                          flexDirection: "column",
                          gap: 0.8,
                          minWidth: "fit-content",
                          maxWidth: "65px",
                          marginRight: "2px",
                        }}
                      >
                        <Box
                          sx={{
                            p: 0.8,
                            minWidth: 40,
                            border: "2px solid #E1E1E1",
                            borderRadius: "10px",
                            backgroundColor: "#F5F5F580",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "column",
                          }}
                        >
                          <Typography fontWeight={600}>
                            {patient?.visited_at?.split(" ")?.[1] || "N/A"}
                          </Typography>
                          <Typography fontSize={12} variant="body_Grey">
                            {patient?.visited_at?.split(" ")?.[2]}
                          </Typography>
                        </Box>
                        <VisitTypeChip type={patient?.visit_type} />
                      </Box>

                      {/* PATIENT INFO */}
                      <Box
                        sx={{
                          flex: 1,
                          display: "flex",
                          flexDirection: "column",
                          gap: 0.1,
                        }}
                      >
                        {/* Patient Name */}
                        <Typography variant="heading2">
                          {patient?.patient_name}
                        </Typography>

                        {/* Father / Spouse / Guardian */}
                        {patient?.father_or_husband && (
                          <Typography
                            sx={{
                              fontSize: 14,
                              color: "#757575",
                              fontWeight: 500,
                            }}
                          >
                            {patient?.father_or_husband}
                          </Typography>
                        )}

                        {/* UID + Phone */}
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.6,
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: 12,
                              color: "#9E9E9E",
                              fontWeight: 500,
                            }}
                          >
                            #{patient?.uid}
                          </Typography>

                          <Typography
                            sx={{ color: "#BDBDBD", marginRight: "-2px" }}
                          >
                            •
                          </Typography>
                          <LocalPhoneOutlinedIcon
                            sx={{ fontSize: 12, color: "#9E9E9E" }}
                          />
                          <Typography
                            sx={{
                              fontSize: 12,
                              color: "#9E9E9E",
                              fontWeight: 500,
                            }}
                          >
                            {patient?.mobile}
                          </Typography>
                        </Box>

                        {/* Visit Date & Time */}
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          {/* <Typography sx={{ fontSize: 12, color: "#9E9E9E" }}>
                            {patient?.visit_date}
                          </Typography>

                          <Typography
                            sx={{ color: "#BDBDBD", marginRight: "-2px" }}
                          >
                            •
                          </Typography> */}
                          <Typography sx={{ fontSize: 12, color: "#9E9E9E" }}>
                            {patient?.visit_time}
                          </Typography>
                        </Box>
                      </Box>

                      {/* ACTIONS + VISIT TYPE */}
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          // gap: 0.5,
                          minWidth: "fit-content",
                          flexWrap: "wrap",
                        }}
                      >
                        <IconButton
                          onClick={(e) => pinAppointment(patient?.id, e)}
                        >
                          {patient.pinned_sequence > 0 ? (
                            <PushPinIcon sx={{ color: "teal", fontSize: 20 }} />
                          ) : (
                            <PushPinOutlinedIcon
                              sx={{ color: "teal", fontSize: 20 }}
                            />
                          )}
                        </IconButton>

                        <IconButton
                          onClick={(e) =>
                            handleRedirect(patient?.patient_id, e)
                          }
                        >
                          <OpenInNewOutlinedIcon
                            sx={{ color: "#FF8D1E", fontSize: 20 }}
                          />
                        </IconButton>

                        <IconButton
                          onClick={(e) =>
                            cancelPatientAppointment(patient?.id, e)
                          }
                        >
                          <CloseIcon sx={{ color: "red", fontSize: 20 }} />
                        </IconButton>
                      </Box>
                    </Box>
                  ))
                ) : (
                  /* EMPTY STATE */
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      mt: 10,
                      backgroundColor: "#EEF6F9",
                      borderRadius: "20px",
                      height: 185,
                    }}
                  >
                    <Box sx={{ marginTop: "-80px", marginLeft: "-25px" }}>
                      <img src={bye} alt="" width={"250px"} />
                    </Box>
                    <Box>
                      <Typography fontSize={22} fontWeight="bold">
                        All Done,
                      </Typography>
                      <Typography fontSize={22} fontWeight="bold">
                        You've made it 🎉
                      </Typography>
                    </Box>
                  </Box>
                )}
              </Box>
            )

            // (
            //   <TableContainer
            //     // component={Paper}
            //     sx={{
            //       mt: 2,
            //       maxHeight: "100vh",
            //       minHeight: "70vh",
            //       // backgroundColor: "#EEF6F9",
            //       overflowY: "auto",  // Enable scrolling
            //       "::-webkit-scrollbar": {
            //         display: "none", // Hide scrollbar for webkit browsers
            //       },
            //       scrollbarWidth: "none",
            //     }}
            //   >
            //     <Table sx={{
            //       overflowY: "auto",  // Enable scrolling
            //       "::-webkit-scrollbar": {
            //         display: "none", // Hide scrollbar for webkit browsers
            //       },
            //       scrollbarWidth: "none",
            //     }}>
            //       <TableHead>
            //         <TableRow>
            //           <TableCell sx={tableCellStyle}>
            //             <Typography variant="small_Text1">Name </Typography>
            //           </TableCell>
            //           <TableCell sx={tableCellStyle}>
            //             <Typography variant="small_Text1">Patient ID</Typography>
            //           </TableCell>
            //           <TableCell sx={tableCellStyle}>
            //             <Typography variant="small_Text1">Visit Time</Typography>
            //           </TableCell>
            //           <TableCell sx={{
            //             ...tableCellStyle, textAlign: 'center'
            //           }}>
            //             <Typography variant="small_Text1">Actions</Typography>
            //           </TableCell>
            //         </TableRow>
            //       </TableHead>
            //       {filterList?.appointments?.length > 0 ? (
            //         <TableBody>
            //           {filterList?.appointments?.map((patient, index) => (
            //             <TableRow
            //               sx={{
            //                 // INNER BORDER using outline
            //                 outline:
            //                   selectedRow === patient?.patient_id
            //                     ? "2px solid #007A99"
            //                     : "2px solid #E1E1E1",
            //                 outlineOffset: "-3px",

            //                 borderRadius: "16px !important",
            //                 backgroundColor: "white",
            //                 paddingY: "6px",
            //                 cursor: "pointer",
            //                 borderBottom: "8px solid #EEF6F9",
            //                 borderTop: index === 0 ? "6px solid #EEF6F9" : "",
            //                 "&:hover": {
            //                   transform: "scale(1.001)", // Slight scaling for the pop-up effect
            //                   borderRadius: "16px !important",
            //                 },
            //               }}
            //               onClick={() => {
            //                 handleSelect(patient?.patient_id, patient?.id);
            //                 setSelectedRow(patient?.patient_id);
            //               }}
            //             >
            //               <TableCell
            //                 sx={{
            //                   padding: "10px",
            //                   pl: "16px",
            //                   borderTopLeftRadius: "20px",
            //                   borderBottomLeftRadius: "20px",
            //                   marginBottom: "10px",
            //                 }}
            //               >
            //                 <Typography variant="heading2">
            //                   {patient?.patient_name}
            //                 </Typography>
            //                 <Box sx={{ display: "flex", alignItems: "center" }}>
            //                   <MobileScreenShareRoundedIcon
            //                     sx={{ height: "10px", width: "12px" }}
            //                   />
            //                   <Typography variant="body2_text">
            //                     {patient?.mobile}
            //                   </Typography>
            //                 </Box>
            //               </TableCell>
            //               <TableCell sx={{ p: "10px", pl: "16px" }}>
            //                 <Typography variant="body_Grey1" color="text.black">
            //                   {patient?.uid}
            //                 </Typography>
            //               </TableCell>
            //               <TableCell sx={{ p: "10px", pl: "16px" }}>
            //                 <Typography color="text.black" variant="body3_text">
            //                   {patient?.visit_date}
            //                 </Typography>
            //                 <br />
            //                 <Typography color="text.black1" variant="body2_text">
            //                   {patient?.visit_time}
            //                 </Typography>
            //               </TableCell>
            //               <TableCell
            //                 sx={{
            //                   p: "10px",
            //                   pl: "16px",
            //                   borderTopRightRadius: "20px",
            //                   borderBottomRightRadius: "20px",
            //                   textAlign: 'center'
            //                 }}
            //               >
            //                 <IconButton sx={actionIconStyle}>
            //                   <CloseIcon
            //                     sx={{
            //                       // ...xBtn,
            //                       borderRadius: "50%",
            //                       padding: "5px",
            //                       width: "22px",
            //                       height: "22px",
            //                       color: 'red'
            //                     }}
            //                     onClick={(e) =>
            //                       cancelPatientAppointment(patient?.id, e)
            //                     }
            //                   />
            //                 </IconButton>
            //                 <IconButton sx={actionIconStyle}>
            //                   {patient.pinned_sequence > 0 ?
            //                     <PushPinIcon disabled={isLoading}
            //                       sx={{
            //                         borderRadius: "50%",
            //                         padding: "2px",
            //                         color: 'teal',
            //                         width: "22px",
            //                         height: "22px",
            //                         margin: "5px",
            //                       }}
            //                       onClick={(e) => pinAppointment(patient?.id, e)} />
            //                     :
            //                     <PushPinOutlinedIcon
            //                       disabled={isLoading}
            //                       sx={{
            //                         borderRadius: "50%",
            //                         padding: "2px",
            //                         color: 'teal',
            //                         width: "22px",
            //                         height: "22px",
            //                         margin: "5px",
            //                       }}
            //                       onClick={(e) => pinAppointment(patient?.id, e)}
            //                     />
            //                   }

            //                 </IconButton>
            //                 <IconButton sx={actionIconStyle}>
            //                   <OpenInNewOutlinedIcon
            //                     sx={{
            //                       // backgroundColor: "#FF8D1E",
            //                       // color: "white",
            //                       borderRadius: "50%",
            //                       px: "5px",
            //                       py: "5px",
            //                       width: "20px",
            //                       height: "20px",
            //                       color: "#FF8D1E",
            //                       "&:hover": {
            //                         color: "orange",
            //                       },
            //                     }}
            //                     onClick={(e) =>
            //                       handleRedirect(patient?.patient_id, e)
            //                     }
            //                   />
            //                 </IconButton>

            //               </TableCell>
            //             </TableRow>
            //           ))}
            //         </TableBody>
            //       ) : (
            //         <TableRow></TableRow>
            //       )}
            //     </Table>

            //     <Box
            //       sx={{
            //         width: "100%",
            //         display: filterList?.appointments?.length > 0 ? "none" : "",
            //       }}
            //     >
            //       <Box
            //         sx={{
            //           width: "100%",
            //           display: "flex",
            //           alignItems: "center",
            //           flexDirection: "row",
            //           justifyContent: "center",
            //           backgroundColor: "#EEF6F9",
            //           borderRadius: "20px",
            //           height: "185px",
            //           marginTop: "100px",
            //         }}
            //       >
            //         <Box sx={{ marginTop: "-80px", marginLeft: "-25px" }}>
            //           <img src={bye} alt="" width={"250px"} />
            //         </Box>

            //         <Box sx={{ paddingRight: "30px", marginTop: "-14px" }}>
            //           <Typography
            //             fontSize={"24px"}
            //             fontWeight={"bold"}
            //             color={"neutral.teal"}
            //           >
            //             All Done,{" "}
            //             <br />
            //             <Typography variant="span" color={"black"}>
            //               {" "}
            //               You've made it{" "}
            //             </Typography>{" "}
            //           </Typography>
            //           {/* <Typography fontSize={'24px'}  fontWeight={'bold'} >You've made it </Typography> */}
            //           <Typography sx={{ marginTop: "8px", color: 'neutral.black' }}>
            //             {" "}
            //             Good Bye !
            //           </Typography>
            //         </Box>
            //       </Box>
            //     </Box>
            //   </TableContainer>
            // )
          }
        </Grid>
      )}

      <Modal
        open={allDataLoading}
        //onClose={}
        sx={{
          border: "none",
          position: "absolute",
          top: "40%",
          left: "40%",
          // border:'1px solid transparent',
        }}
      >
        <Box
          sx={{
            animation: `${rotateSpinner} 1s linear infinite`,
            width: "50px",
            border: "none !important",
            outline: "none !important",
          }}
        >
          <img
            src={loadingSpinner}
            alt=""
            style={{
              width: "50px",
              height: "50px",
              border: "none !important",
              outline: "none !important",
            }}
          />
        </Box>
      </Modal>

      <PatientSummaryDialog
        openSummaryModal={openSummaryModal}
        handleCloseSummary={handleCloseSummary}
        voiceSummary={voiceSummary}
        isFetching={false}
        // appointmentData={ }
      />

      {/* Patient AI History Summary Modal */}
      <CustomModal
        open={openHistoryModal && !!patientAiSummaryData}
        onClose={() => setOpenHistoryModal(false)}
        customStyles={{ minWidth: "80%", p: 2.5 }}
      >
        <PatientHistorySummary
          summary={patientAiSummaryData}
          onClose={() => setOpenHistoryModal(false)}
          onContinue={() => setOpenHistoryModal(false)}
        />
      </CustomModal>
    </Grid>
  );
};

export default DoctorDetail;
